const TRUNC_STATUSES = {
  pending: { name: "pending", id: "pending" },
  active: { name: "ACTIVE", id: "ACTIVE" },
  failed: { name: "FAILED", id: "FAILED" },
  processed: { name: "PROCESSED", id: "PROCESSED" },
};

export default TRUNC_STATUSES;
